<template>
  <!--<div class="grid-container"
       :style="`grid-template-columns: repeat(${columns}, 1fr);
                ${rows >= 1? `grid-template-rows: repeat(${rows}, 1fr);` : ''}
                ${customStyle};
                `"
  >-->
  <div class="grid-container"
       :style="`grid-template-columns: repeat(${columns}, 1fr);
                ${customStyle};
                `"
  >
    <slot />
  </div>
</template>

<script setup>
import { defineProps, onMounted, onUnmounted, ref, computed } from 'vue'

const columns = computed(() => windowWidth.value < 768 ? props.xsColumns : props.normalColumns)
// const rows = computed(() => windowWidth.value < 768 ? props.xsRows : props.normalRows)

const props = defineProps({
  normalColumns: {
    type: Number,
    default () {
      return 4
    }
  },
  normalRows: {
    type: Number,
    default () {
      return 4
    }
  },
  xsColumns: {
    type: Number,
    default () {
      return 1
    }
  },
  xsRows: {
    type: Number,
    default () {
      return 4
    }
  },
  customStyle: {
    type: String,
    default () {
      return ''
    }
  }

})

const windowWidth = ref(1000)

onMounted(async () => {
  windowWidth.value = window.innerWidth
  window.addEventListener('resize', myEventHandler)
})

onUnmounted(async () => {
  window.removeEventListener('resize', myEventHandler)
})

function myEventHandler (e) {
  windowWidth.value = window.innerWidth
}

</script>
<style lang="scss" scoped>
    .grid-container {
        display: grid;
        margin-bottom: 20px;
        overflow-y: auto;
        gap: 30px;
    }

</style>
